import * as actions from './actions';

const initialState = () => {
    return {
        isBusy: false,
        items: [],
        error: null
    };
};

export default function(state = initialState(), action) {
    switch (action.type) {
        case actions.FETCH_BROKERAGES:
            return {
                ...state,
                isBusy: true,
                error: null
            };
        case actions.FETCH_BROKERAGES_SUCCESS:
            return {
                ...state,
                isBusy: false,
                items: action.value
            };
        case actions.FETCH_BROKERAGES_FAILURE:
            return {
                ...state,
                isBusy: false,
                error: action.value
            };
        default:
            return state;
    }
}
